const brandingConfig = require('./branding-config');

module.exports = brandingConfig;